import { render } from "./createproduct.vue?vue&type=template&id=2ee1b9b1&scoped=true"
import script from "./createproduct.vue?vue&type=script&lang=js"
export * from "./createproduct.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createproduct.vue?vue&type=style&index=1&id=2ee1b9b1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee1b9b1"]])

export default __exports__